import { useSearch } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { SubscriptionCheckoutStep } from './SubscriptionCheckoutStep';

export function OnboardingCheckoutRoute(): ReactElement {
    const { payment } = useSearch({ strict: false });
    return <SubscriptionCheckoutStep payment={payment} />;
}
